import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { patch } from "@rails/request.js"

// A page's tiles: drag one by its handle, or cycle its width, and the page keeps the
// arrangement (Admin::LayoutsController stores it).
export default class extends Controller {
  static values = { url: String, page: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-bento-handle]",
      draggable: "[data-bento-key]",
      animation: 150,
      // Pointer events rather than native drag and drop: the same drag in every browser.
      forceFallback: true,
      onEnd: () => this.save()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  resize(event) {
    const tile = event.target.closest("[data-bento-key]")
    tile.dataset.span = Number(tile.dataset.span) % 4 + 1
    this.save()
  }

  save() {
    const tiles = [...this.element.querySelectorAll(":scope > [data-bento-key]")]
    const spans = Object.fromEntries(
      tiles.filter(tile => tile.dataset.span !== tile.dataset.defaultSpan).map(tile => [tile.dataset.bentoKey, tile.dataset.span])
    )

    patch(this.urlValue, {
      body: JSON.stringify({ page: this.pageValue, order: tiles.map(tile => tile.dataset.bentoKey), spans }),
      contentType: "application/json"
    })
  }
}
